import React from "react"
import Image from "gatsby-plugin-sanity-image"

import { StandardBlockWrapper } from "./standardBlockWrapper"
import { ResponsiveImage } from "../media/responsiveImage"

const PageTransition = ({
  image,
  backgroundImage,
  imagePosition,
  backgroundColor,
  padding,
}) => {
  const imageClasses =
    imagePosition === "left"
      ? "md:col-end-12 lg:col-start-3 lg:col-end-9"
      : imagePosition === "center"
      ? "lg:col-start-3 lg:col-end-13"
      : imagePosition === "right" && "lg:col-start-7 lg:col-end-13"

  return (
    <StandardBlockWrapper
      backgroundColor={backgroundColor}
      padding={padding}
      className="grid grid-cols-14 relative"
    >
      {image && image.asset && (
        <div
          className={`col-start-2 col-end-14 my-7 relative z-20 ${imageClasses}`}
        >
          <Image {...image} className="w-full" />
        </div>
      )}
      {backgroundImage && (
        <ResponsiveImage
          {...backgroundImage}
          className="absolute w-full z-0 h-full object-cover top-0 left-0"
        />
      )}
    </StandardBlockWrapper>
  )
}

export default PageTransition
